export default "__VITE_ASSET__UIVGz3o6__"